import TileRangeClass, * as TileRangeModule from './../node_modules/ol/TileRange.js';

// Create a wrapper class
class TileRange extends TileRangeClass{
    constructor(options) {
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in TileRangeModule) {
    if (key !== "default") {
        TileRange[key] = TileRangeModule[key];
    }
}

export default TileRange;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/TileRange.js';